import { z } from 'zod';
import { parsePauzeVenster } from '../types/settings.js';
/** Zet een gevalideerde `"HH:MM"`-string om naar minuten sinds middernacht. */
function timeToMinutes(time) {
    const hours = Number(time.slice(0, 2));
    const minutes = Number(time.slice(3, 5));
    return hours * 60 + minutes;
}
/**
 * Zod-schema voor de waarde van `verlof/pauze_venster` (Epic 1 — Verlof
 * correctie/kort verlof, Story 1.1, AC-3). Dit is de ENIGE toets op de
 * inhoud van het pauzevenster — het schrijfpad (`PUT /settings/system`) en
 * het instellingenscherm (`SystemSettingsTab`) gebruiken hem allebei, zodat
 * er geen tweede, afwijkende validatie ontstaat.
 *
 * Toetst, in volgorde:
 * 1. de vorm `"HH:MM-HH:MM"` (via `parsePauzeVenster`);
 * 2. dat de eindtijd STRIKT na de begintijd ligt (een gelijke tijd is een
 *    venster van nul minuten, dus ongeldig — `13:00-12:30` en
 *    `00:00-00:00` worden beide geweigerd);
 * 3. impliciet daarmee: geen venster van nul minuten.
 */
export const pauzeVensterSchema = z
    .string()
    .refine((raw) => parsePauzeVenster(raw) !== null, {
    message: 'Vul een tijd in, bijvoorbeeld 12:30.',
})
    .refine((raw) => {
    const venster = parsePauzeVenster(raw);
    if (!venster)
        return true; // al afgevangen door de vorm-toets hierboven
    return timeToMinutes(venster.end) > timeToMinutes(venster.start);
}, { message: 'De eindtijd moet later zijn dan de begintijd.' });
//# sourceMappingURL=settings.js.map